// src/services/itemService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getItems = async () => {
  return await axios.get(`${API_URL}/products`);
};

const getItemsByEventId = async (id) => {
  const event_id = id ? id : parseInt(localStorage?.getItem('event_id'));
  return await axios.get(`${API_URL}/products/productsbyevent/${event_id}`);
};

const getItemDetails = async () => {
  return await axios.get(`${API_URL}/products/details`);
};

const getItem = async (id) => {
  return await axios.get(`${API_URL}/products/${id}`);
};

const createItem = async (itemData) => {
  return await axios.post(`${API_URL}/products/`, itemData);
};

const updateItem = async (id, itemData) => {
  return await axios.put(`${API_URL}/products/${id}`, itemData);
};

// const deleteItem = async (id) => {
//   return await axios.delete(`${API_URL}/products/${id}`);
// };

const deleteItem = async (item_id, event_id) => {
  return await axios.delete(
    `${API_URL}/events/${event_id}/products/${item_id}`
  );
};

const deleteProductList = async (data) => {
  return await axios.post(`${API_URL}/common/setclearrows`, data);
};

const assignProducts = async (data, id) => {
  return await axios.post(`${API_URL}/events/${id}/products/assign`, data);
};

export default {
  getItems,
  getItemsByEventId,
  getItemDetails,
  getItem,
  createItem,
  updateItem,
  deleteItem,
  deleteProductList,
  assignProducts,
};
